import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

export default function RemoveButton({
  disabled,
  onClick,
}: {
  disabled: boolean
  onClick: () => void
}): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <button
      className="flex flex-col items-center space-y-2 disabled:opacity-50 disabled:cursor-not-allowed exclude-from-screenshot"
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <SVGImage alt={t('resetButton')} height={16} srcKey="bootcamp/redX.svg" width={16} />
      <p className="text-2.5 font-semibold leading-none">{t('reset')}</p>
    </button>
  )
}
